import { setupCache } from "axios-cache-adapter";

/**
 * Se encarga de cachear los request del tipo get
 */
class CacheHelper {
  app = null;
  /**
   * @constructor
   */
  constructor() {
    this.init();
  }

  get() {
    if (this.app === null) {
      this.init();
    }
    return this.app;
  }

  init() {
    let thiz = this;
    this.app = setupCache({
      limit: 20,
      clearOnError: true,
      maxAge: 1 * 60 * 1000,
      exclude: {
        query: false,
        filter: function(data) {
          if (
            data.method !== "post" &&
            data.method !== "put" &&
            data.method !== "delete"
          ) {
            return false;
          }
          let path = data.url;
          if (data.method !== "post") {
            let idx = data.url.lastIndexOf("/");
            path = data.url.substr(0, idx);
          }
          let store = thiz.app.store.store;
          console.log(store);
          for (let url in store) {
            console.log(url, path, url.indexOf(path));
            if (url.indexOf(path) == 0) {
              delete store[url];
            }
          }
          return false;
        }
      }
    });
  }

  clean() {
    this.app.store.store = {};
  }
}

export default new CacheHelper();
